import { ContactForm } from "../../components/ContactForm/index";

export const ContactMe = () => {
  return (
    <div>
      <ContactForm />
    </div>
  );
};
